import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { errorRoute } from './layouts/error/error.route';
import { UserRouteAccessService } from '../services/user-route-access.service';
import { AvailableTransporterGuard } from './guards/available-transorter.guard';
import { currentCustomerResolve } from '../resolvers/current-customer.resolve';
import { PATHS } from '../models/bary-paths.model';
import { CurrentTransporterResolver } from './+middle/transporter/middle-transporter.resolver';

@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {
          path: '',
          loadChildren: () => import('./+static/static.routing.module').then(m => m.StaticRoutingModule),
        },
        {
          path: PATHS.ADMIN.last,
          data: {
            authorities: ['ROLE_ADMIN'],
          },
          canActivate: [UserRouteAccessService],
          loadChildren: () => import('./admin/admin-routing.module').then(m => m.AdminRoutingModule),
        },
        {
          path: PATHS.MIDDLE.last,
          data: {
            authorities: ['ROLE_MODERATOR', 'ROLE_ADMIN'],
          },
          resolve: {
            transporter: CurrentTransporterResolver,
            customer: currentCustomerResolve,
          },
          canActivate: [UserRouteAccessService, AvailableTransporterGuard],
          loadChildren: () => import('./+middle/middle-routing.module').then(m => m.MiddleRoutingModule),
        },
        {
          path: PATHS.ACCOUNT.last,
          loadChildren: () => import('./own/account/account.module').then(m => m.AccountModule),
        },
        {
          path: PATHS.USER.last,
          canActivate: [UserRouteAccessService],
          resolve: {
            customer: currentCustomerResolve,
          },
          data: {
            authorities: ['ROLE_USER', 'ROLE_MODERATOR'],
          },
          loadChildren: () => import('./+user/user-routing.module').then(m => m.UserRoutingModule),
        },
        {
          path: PATHS.PAYMENT.last,
          data: {
            authorities: ['ROLE_USER'],
          },
          canActivate: [UserRouteAccessService],
          loadChildren: () => import('./+payment/payment.module').then(m => m.PaymentModule),
        },
        {
          path: PATHS.ORDER.last,
          data: {
            authorities: ['ROLE_USER'],
          },
          canActivate: [UserRouteAccessService],
          loadChildren: () => import('./+orders/orders.module').then(m => m.OrdersModule),
        },
        {
          path: PATHS.LOGIN.last,
          loadComponent: () => import('./login/login-modal.component').then(v => v.LoginModalComponent),
        },
        ...errorRoute,
      ],
      { enableTracing: false, paramsInheritanceStrategy: 'always' }
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
